import Multiselect from "vue-multiselect";

export default {
  name: "filter-field",

  data() {
    return {
      selected: null
    };
  },

  props: ["filter"],

  computed: {
    fieldOptions() {
      if (this.filter && this.filter.values) {
        return this.filter.values;
      } else {
        return [];
      }
    }
  },

  mounted: function() {
    let filters = this.$store.getters.getFilters.filters;

    if (!filters) {
      return false;
    }

    let userCurrentFilter = filters.find(f => f.tagId == this.filter.tagId);

    if (userCurrentFilter) {
      this.selected = JSON.parse(userCurrentFilter.value);
    }
  },

  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    changeFilterField(filter) {
      let currentFilter = {
        tagId: filter.tagId,
        value: JSON.stringify(this.selected)
      };

      this.$emit("updateSearchParams", currentFilter);
    }
  },

  components: {
    Multiselect
  }
};
